import {SpeedUnit} from '@/common/constants/units';

export function speedReduce(msValue: number, unit: SpeedUnit) {
	switch (unit) {
		case SpeedUnit.ms:
			return Math.round(msValue * 10) / 10;

		case SpeedUnit.kph:
			return Math.round(msValue * 3.6);

		case SpeedUnit.mph:
			return Math.round(msValue * 2.237);
	}
}
